import React, { PureComponent } from 'react';
import {
  SafeAreaView,
  StyleSheet, View, Text,
  Linking,
  TouchableOpacity,
} from 'react-native';
import { connect } from 'react-redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import { defaultScale } from '../../../../utils/scaling';
import { getNextStep, navigateToNextStep } from '../../../actions';
import { IAppStore } from '../../../../HomeWorkouts';
import { GoogleAnalytics } from '../../../../services/google-analytics';
import Theme from '../../../../theme';
import { UserDataConsumer } from '../../../../utils';
import { IConnectedAppOnboardingProps, navigateToNextOnboardingStep } from '../ConnectedAppEntryPointScreen';
import AvailableAppsAppleWatch from '../../../../assets/icons/connected-apps/available-apps-apple-watch.svg';
import FooterButtons from '../shared/FooterButtons';
import MultiStyleText from '../../../../ui/components/MultiStyleText';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: defaultScale(16),
    backgroundColor: Theme.WHITE,
  },
  headerContainer: {
    paddingHorizontal: defaultScale(30),
    alignItems: 'center',
    marginTop: '10%',
    textAlign: 'center',
    flex: 1,
  },
  heading: {
    textAlign: 'center',
  },
  appleHealthIcon: {
    justifyContent: 'center',
    alignItems: 'center',
    shadowOffset: { width: 0, height: 5 },
    shadowColor: Theme.BLACK,
    shadowRadius: 5,
    shadowOpacity: 0.2,
    width: defaultScale(150),
    height: defaultScale(150),
    marginVertical: defaultScale(20),
  },
  subHeader: {
    marginTop: defaultScale(20),
    color: Theme.GREY_DARK_MEDIUM,
    marginBottom: defaultScale(10),
    textAlign: 'center',
    flexDirection: 'column',
    alignItems: 'center',
  },
  link: {
    marginBottom: defaultScale(-2),
    alignSelf: 'baseline',
  },
});

class InstallWatchCompanionApp extends PureComponent<IConnectedAppOnboardingProps & WithTranslation> {
  private readonly googleAnalytics: GoogleAnalytics;

  public constructor(props: IConnectedAppOnboardingProps & WithTranslation) {
    super(props);
    this.googleAnalytics = new GoogleAnalytics();
  }

  public render() {
    const { t } = this.props;

    return (
      <SafeAreaView style={styles.container}>
        <View style={styles.headerContainer}>
          <Text style={[Theme.textStyle.heading, styles.heading]}>{t('installTheCompanionApp')}</Text>
          <View style={styles.subHeader}>
            <MultiStyleText
              templateString={t('installTheCompanionAppInstruction')}
              styleKeys={[
                {
                  keyName: 'watchAppOnYourIphone',
                  keyValue: 'Watch app on your iPhone',
                  style: Theme.textStyle.bodyCopyBold,
                },
                { keyName: 'fitillion', keyValue: 'Fitillion', style: Theme.textStyle.bodyCopyBold },
              ]}
              normalStyle={{ ...Theme.textStyle.bodyCopyReg, textAlign: 'center' }}
            />
          </View>
          <AvailableAppsAppleWatch
            width={defaultScale(320)}
            height={defaultScale(320)}
            style={styles.appleHealthIcon}
          />
        </View>
        <FooterButtons
          primaryButtonText={t('next')}
          onPrimaryButtonPress={() => this.proceedToNextStep()}
          isLoading={false}
        />
      </SafeAreaView>
    );
  }

  private proceedToNextStep = () => {
    navigateToNextOnboardingStep(
      this.props,
      this.props.getNextStep,
      this.props.navigateToNextStep,
    );
    this.googleAnalytics.logEventWithParamaters('sign_up_install_watch_companion_app', { enabled: true });
  };
}

const mapStateToProps = (state: IAppStore) => ({
  enabledFeatures: state.auth.signup.enabledFeatures,
});

const mapDispatchToProps = {
  getNextStep,
  navigateToNextStep,
};

export default withTranslation(['auth', 'settings'])(
  connect(mapStateToProps, mapDispatchToProps)(UserDataConsumer(InstallWatchCompanionApp)),
);
